<template>
  <div>
    <SOSlotBase :bg-white="true" :loading="pageSetting.loading">
      <template v-slot:loading-page>
        <SOLoadingPage />
      </template>

      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Nota Transaksi'"
          :type="'back'"
          @back="back"
        />
      </template>

      <template v-slot:content>
        <div
          v-if="detail.data.detail_transaksi.status_hapus === 1 && !isNoAction"
        >
          <div
            class="bg-yellow p-x-20 p-y-8 d-flex align-items-center border-bottom"
          >
            <img
              src="@/assets/icons/alert-circle-yellow.svg"
              alt=""
              class="m-r-12"
            />
            <div class="d-block">
              <div class="f-regular f-14 f-c-black">
                Nota ini butuh konfirmasi penghapusan
              </div>
              <div class="f-regular f-12 f-c-midgrey">
                Lakukan konfirmasi di halaman pembatalan
              </div>
            </div>
          </div>
          <div
            class="bg-yellow p-x-20 p-y-8 d-flex flex-column justify-content-start border-bottom"
          >
            <SOTextEllipsis
              :line-numbers="3"
              :text-label="'Keterangan:'"
              :text-content="
                detail.data.detail_transaksi.keterangan_permintaan_hapus
              "
            />
          </div>
          <div
            class="bg-yellow p-x-20 p-y-8 f-regular f-12 f-c-midgrey border-bottom"
          >
            Lakukan konfirmasi melalui tombol di bawah.
          </div>
        </div>

        <div
          v-if="
            detail.data.detail_transaksi.is_pengantaran_extra === 1 && false
          "
        >
          <div
            class="bg-yellow p-x-20 p-y-8 d-flex align-items-center border-bottom"
          >
            <img
              src="@/assets/icons/alert-circle-yellow.svg"
              alt=""
              class="m-r-12"
            />
            <div class="d-block">
              <div class="f-regular f-14 f-c-black">
                Tagihan tambahan dari nota ini butuh konfirmasi penghapusan
              </div>
              <div class="f-regular f-12 f-c-midgrey">
                Diminta oleh Egy Wijaya pada 10/12/2020
              </div>
            </div>
          </div>
          <div
            class="bg-yellow p-x-20 p-y-8 f-regular f-12 f-c-midgrey border-bottom"
            @click="
              detailTagihanTambahan(
                detail.data.detail_transaksi.pengantaran_extra
                  .idpengantaranextra
              )
            "
          >
            <span class="f-bold f-c-blue">Klik disini</span> untuk menuju ke
            tagihan tambahan
          </div>
        </div>

        <div class="p-x-20 p-y-20">
          <SOTransaksiDetailProgress
            :transaksi="detail.data.detail_transaksi"
          />
        </div>
        <div class="separator"></div>

        <div class="p-x-20 p-y-20">
          <SOTransaksiInfo :transaksi="detail.data" />
        </div>
        <div class="separator"></div>

        <div
          class="p-x-16"
          :class="{
            'p-y-20': detail.data.detail_transaksi.status_hapus !== 1,
            'p-d-72 p-t-20': detail.data.detail_transaksi.status_hapus === 1,
          }"
          style="
            background: linear-gradient(
              180deg,
              rgba(242, 245, 247, 0) 0%,
              #f2f5f7 100%
            );
          "
        >
          <SOTransaksiDetailTagihan
            :class="{
              'm-d-20': detail.data.detail_transaksi.is_pengantaran_extra === 1,
            }"
            :layanan-reguler="true"
            :transaksi="detail.data"
          />

          <SOTransaksiDetailTagihan
            v-if="detail.data.detail_transaksi.is_pengantaran_extra === 1"
            :transaksi="detail.data"
            :tagihan-tambahan="true"
            :show-detail-tagihan-tambahan="true"
            @detail="
              detailTagihanTambahan(
                detail.data.detail_transaksi.pengantaran_extra
                  .idpengantaranextra
              )
            "
            class="m-t-20"
          />
        </div>

        <div class="p-x-20 p-y-16 bg-white">
          <PengaturanTransaksi :transaksi="detail.data.detail_transaksi" />
        </div>
        <div class="separator" />

        <template v-if="detail.data.detail_transaksi.pengantaran.isantar === 1 && !isLoyaltyTrx">
          <div class="p-x-20 p-y-16 bg-white">
            <SOTransaksiDetailPengantaran
              :pengantaran="detail.data.detail_transaksi.pengantaran"
            />
          </div>
          <div class="separator"></div>
        </template>

        <div class="p-x-20 p-y-16 bg-white m-t-20" v-if="detail.data.item">
          <InventoryTransaksi :inventory="detail.data.item" />
        </div>

        <div class="separator"></div>

        <div
          class="p-x-20 p-y-20"
          v-if="
            detail.data.detail_transaksi.status_hapus === 0 && !isNoAction && !isLoyaltyTrx && validateAccess('transactionRegular.delete')
          "
        >
          <SOButton
            :text="'Hapus Transaksi'"
            :outline-danger="true"
            :full="true"
            @action="
              () => {
                pageSetting.modal.deleteTransaksi = true;
              }
            "
          />
        </div>

        <div
          v-if="
            detail.data.detail_transaksi.status_hapus === 1 &&
            !isNoAction &&
            validateAccess('deleteRegular.confirm')
          "
          class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0 bg-white"
          style="position: fixed; bottom: 64px"
        >
          <div class="btn_actions col-md-6 col-sm-6 col-6 pr-1">
            <SOButton
              :outline="true"
              :full="true"
              :text="'Tolak'"
              @action="tolakPenghapusan"
            />
          </div>
          <div class="btn_actions col-md-6 col-sm-6 col-6 pl-1">
            <SOButton
              :primary="true"
              :full="true"
              :text="'Setujui'"
              @action="setujuiPenghapusan"
            />
          </div>
        </div>
      </template>

      <template v-slot:modal>
        <TransaksiModalHapus
          v-if="pageSetting.modal.deleteTransaksi && detail.data"
          :transaksi="detail.data"
          @close="
            () => {
              pageSetting.modal.deleteTransaksi = false;
            }
          "
        />
        <SOTerimaModal
          v-if="pageSetting.modal.penghapusan.setujui"
          :use-route-push="false"
          @close="
            () => {
              pageSetting.modal.penghapusan.setujui = false;
            }
          "
        />
        <SOTolakModal
          v-if="pageSetting.modal.penghapusan.tolak"
          :use-route-push="false"
          @close="
            () => {
              pageSetting.modal.penghapusan.tolak = false;
            }
          "
        />
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";

import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

import SOTransaksiDetailProgress from "@/so-components/modules/transaksi/reguler/detail/SOTransaksiDetailProgress";
import SOTransaksiInfo from "@/so-components/modules/transaksi/SOTransaksiInfo";
import SOTransaksiDetailTagihan from "@/so-components/modules/transaksi/reguler/detail/SOTransaksiDetailTagihan";
import SOTransaksiDetailPengantaran from "@/so-components/modules/transaksi/reguler/detail/SOTransaksiDetailPengantaran";
import PengaturanTransaksi from "../components/PengaturanTransaksi";

import TransaksiModalHapus from "./modal/TransaksiModalHapus";
import SOTerimaModal from "./../../../penghapusan-transaksi/reguler/components/SOTerimaModal";
import SOTolakModal from "./../../../penghapusan-transaksi/reguler/components/SOTolakModal";

import SOTextEllipsis from "@/so-components/global/ui/SOTextEllipsis";
import InventoryTransaksi from "../components/InventoryTransaksi.vue";

export default {
  name: "TransaksiDetail",
  components: {
    SOSlotBase,

    SOLoadingPage,
    SOTitleBar,
    SOButton,

    SOTransaksiDetailProgress,
    SOTransaksiInfo,
    SOTransaksiDetailTagihan,
    SOTransaksiDetailPengantaran,
    PengaturanTransaksi,

    TransaksiModalHapus,
    SOTerimaModal,
    SOTolakModal,

    SOTextEllipsis,
    InventoryTransaksi,
  },
  computed: {
    ...mapGetters("transaksiModule", {
      detail: "getDetailTransaksi",
    }),
    isNoAction() {
      return this.$route.query.noAction ? true : false;
    },
    isLoyaltyTrx() {
      return this.detail.data.detail_transaksi.transaksi_loyalty != null 
    }
  },
  data() {
    return {
      idtransaksi: "",
      exceptionPembatalanTransaksi: [3, 11],
      pageSetting: {
        loading: true,
        modal: {
          deleteTransaksi: false,
          penghapusan: {
            setujui: false,
            tolak: false,
          },
        },
      },
    };
  },
  mounted() {
    this.idtransaksi = this.$route.params.idtransaksi;
    if (this.$route.query.modalOpen !== undefined) {
      if (this.$route.query.modalOpen === true) {
        setTimeout(() => {
          this.pageSetting.modal.deleteTransaksi = true;
        }, 1000);
      }
    }
    this.getDetailTransaksi();
    this.smartTrackingView("detail_transaksi_reguler", {
      idtransaksi: this.idtransaksi,
    });
  },
  methods: {
    back() {
      this.$router.back();
    },

    async getDetailTransaksi() {
      const res = await this.$store.dispatch(
        "transaksiModule/fetchDetailTransaksi",
        this.idtransaksi
      );
      this.pageSetting.loading = false;
      if (!res.success) {
        this.$toast.error(res.err);
        this.$router.back();
      }
    },
    detailTagihanTambahan(id) {
      this.$router.push("/transaksi/reguler/detail/nota_tambahan/" + id);
    },
    setujuiPenghapusan() {
      let isException = false;
      this.detail.data.rincian_pembayaran.forEach((v) => {
        if (this.exceptionPembatalanTransaksi.includes(v.jenis_bayar)) {
          isException = true;
        }
      });
      if (isException) {
        this.pageSetting.modal.deleteTransaksi = true;
      } else {
        this.pageSetting.modal.penghapusan.setujui = true;
      }
    },
    tolakPenghapusan() {
      this.pageSetting.modal.penghapusan.tolak = true;
    },
  },
  beforeDestroy() {
    this.$store.commit("transaksiModule/resetDetailTransaksi");
  },
};
</script>

<style scoped>
.view-screen {
  padding-bottom: 0 !important;
}
</style>
